import RemoveFeature from './RemoveFeature';

export default RemoveFeature;
